import type { ComponentType } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Busca } from './Busca';
import { Decisoes } from './Decisoes';
import { Doc } from './Doc';
import { Impacto } from './Impacto';
import { NotasDoTime } from './NotasDoTime';
import { Overview } from './Overview';
import { Projetos } from './Projetos';
import { Rastreabilidade } from './Rastreabilidade';
import { Revisao } from './Revisao';
import { Saude } from './Saude';
import { Sessoes } from './Sessoes';
import { Usuarios } from './Usuarios';
import { Grafo } from '../grafo/Grafo';
import { ABA_PADRAO } from '../layout/catalogo';

// Ponto único onde a aba da URL se torna uma tela.
//
// Existe em vez de treze rotas no roteador porque a aba já chega aqui validada
// pela casca: está no catálogo e o usuário tem cargo para ela. Aba do catálogo
// sem entrada aqui é erro de programação, e cai na aba padrão em vez de deixar o
// painel em branco.
const TELAS: Record<string, ComponentType<{ slug: string }>> = {
  overview: Overview,
  doc: Doc,
  graph: Grafo,
  search: Busca,
  notes: NotasDoTime,
  sessions: Sessoes,
  review: Revisao,
  decisions: Decisoes,
  impact: Impacto,
  health: Saude,
  commits: Rastreabilidade,
  admin: Projetos,
  users: Usuarios,
};

export function Tela() {
  const { slug = '', aba = '' } = useParams();
  const Escolhida = TELAS[aba];
  if (!Escolhida) return <Navigate to={`/p/${slug}/${ABA_PADRAO}`} replace />;
  return <Escolhida slug={slug} />;
}
